import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const authenticateUserThunk = createAsyncThunk(
  "login/authenticate",
  async (user) => {
    // let response = await api.post("/authenticateuser", user);
    let response = await api.get(`/authUserCred/${user.userid?.trim()}/${user.pswd?.trim()}`);
    // authUserCred/:userid/:pswd
    return response.data;
  }
);

export const getUserAppSession = createAsyncThunk(
  "syncAppSession/get",
  async (params) => {
    // const{type,bosy,payu} = params
    let response = await api.get(
      `/getUserAppSession/${params?.app}/${params?.usertype}/${params?.userId}/${params?.deviceId}`
    );
    return {
      data: response.data,
      status: response.status,
    };
  }
);

export const postSyncAppSessionThunk = createAsyncThunk(
  "syncAppSession/post",
  async (body) => {
    let response = await api.put("syncAppSession", body);
    return {
      data: response.data,
      status: response.status,
    };
  }
);

export const updateSyncAppSessionThunk = createAsyncThunk(
  "syncAppSession/update",
  async (body) => {
    // const{userid,app,appVersion} = body
    let response = await api.patch(
      `updateLogoutSession/${body?.userid}/${body?.app}/${body?.appVersion}`
    );
    return response.data;
  }
);
